module.exports = __webpack_public_path__ + "img/management-component-bg.383bea84.webp";